import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  OFFICE_HOURS_SESSION_TYPES,
  SOLUTION_SESSION_IDS,
} from '@backrs_ui/grow-ui/src/models/models';

import { ActionStickerCardSection, HomePageSection } from './useGetHomePageSections';

const BUILD_STRONG_PROFILE_STRINGS = appStrings.modules.home.sections.upYourGame.buildStrongProfile;
const EXPLORE_CAREER_STRINGS = appStrings.modules.home.sections.upYourGame.exploreCareers;
const BUILD_SOCIAL_CAPITAL_STRINGS = appStrings.modules.home.sections.upYourGame.buildSocialCapital;

export const BUILD_STRONG_PROFILE_SECTION = ({
  navigate,
  getCompetencyUrl,
}: HomePageSection): ActionStickerCardSection => ({
  title: BUILD_STRONG_PROFILE_STRINGS.title,
  description: BUILD_STRONG_PROFILE_STRINGS.description,
  actionStickerCards: [
    {
      title: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.resumeOptimizer.title,
      description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.resumeOptimizer.description,
      stickerUrl: '/images/stickers/Resume.png',
      onClick: () =>
        navigate(
          APP_ROUTE.OFFICE_HOURS.replace(':id?', OFFICE_HOURS_SESSION_TYPES.RESUME_OPTIMIZER),
        ),
    },
    {
      title: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.majorsAndCourses.title,
      description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.majorsAndCourses.description,
      stickerUrl: '/images/stickers/Audiobook.png',
      onClick: () => navigate(getCompetencyUrl('Classes, majors, degrees')),
    },
    {
      title: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.studying.title,
      description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.studying.description,
      stickerUrl: '/images/stickers/Studying.png',
      onClick: () => navigate(getCompetencyUrl('Studying')),
    },
    {
      title: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.boostYourProfile.title,
      description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.boostYourProfile.description,
      stickerUrl: '/images/stickers/Photography.png',
      onClick: () =>
        navigate(
          APP_ROUTE.OFFICE_HOURS.replace(':id?', OFFICE_HOURS_SESSION_TYPES.BOOST_YOUR_PROFILE),
        ),
    },
  ],
});

export const EXPLORE_CAREER_SECTION = ({
  navigate,
  getCompetencyUrl,
}: HomePageSection): ActionStickerCardSection => ({
  title: EXPLORE_CAREER_STRINGS.title,
  description: EXPLORE_CAREER_STRINGS.description,
  actionStickerCards: [
    {
      title: EXPLORE_CAREER_STRINGS.actionStickerCards.tracksToSucceed.title,
      description: EXPLORE_CAREER_STRINGS.actionStickerCards.tracksToSucceed.description,
      stickerUrl: '/images/stickers/RocketShip.png',
      onClick: () => navigate(APP_ROUTE.CAREER_TRACKS),
    },
    {
      title: EXPLORE_CAREER_STRINGS.actionStickerCards.shadowing.title,
      description: EXPLORE_CAREER_STRINGS.actionStickerCards.shadowing.description,
      stickerUrl: '/images/stickers/ContactCard.png',
      onClick: () => navigate(getCompetencyUrl('Shadowing')),
    },
    {
      title: EXPLORE_CAREER_STRINGS.actionStickerCards.jobsPathsForYou.title,
      description: EXPLORE_CAREER_STRINGS.actionStickerCards.jobsPathsForYou.description,
      stickerUrl: '/images/stickers/JobsPaths.png',
      onClick: () => navigate(APP_ROUTE.CAREER_PATHS),
    },
    {
      title: EXPLORE_CAREER_STRINGS.actionStickerCards.successDecoded.title,
      description: EXPLORE_CAREER_STRINGS.actionStickerCards.successDecoded.description,
      stickerUrl: '/images/stickers/Computer.png',
      onClick: () => navigate(APP_ROUTE.COMING_SOON),
    },
  ],
});

export const BUILD_SOCIAL_CAPITAL_SECTION = ({
  navigate,
  getCompetencyUrl,
}: HomePageSection): ActionStickerCardSection => ({
  title: BUILD_SOCIAL_CAPITAL_STRINGS.title,
  description: BUILD_SOCIAL_CAPITAL_STRINGS.description,
  actionStickerCards: [
    {
      title: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.networking.title,
      description: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.networking.description,
      stickerUrl: '/images/stickers/Microphone.png',
      onClick: () => navigate(getCompetencyUrl('Networking')),
    },
    {
      title: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.commonThreads.title,
      description: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.commonThreads.description,
      stickerUrl: '/images/stickers/VideoCamera.png',
      onClick: () =>
        navigate(APP_ROUTE.SOLUTION_SESSION.replace(':id?', SOLUTION_SESSION_IDS.COMMON_THREADS)),
    },
    {
      title: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.seekSupport.title,
      description: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.seekSupport.description,
      stickerUrl: '/images/stickers/MagnifyingGlass.png',
      onClick: () => navigate(getCompetencyUrl('Seeking support')),
    },
    {
      title: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.engageTeachers.title,
      description: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.engageTeachers.description,
      stickerUrl: '/images/stickers/Waving.png',
      onClick: () => navigate(getCompetencyUrl('Engaging teachers')),
    },
  ],
});
